import { ErrorHandler, Injectable, Injector, inject } from "@angular/core";
import { LocationStrategy, PathLocationStrategy } from "@angular/common";
import * as StackTrace from "stacktrace-js";

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  private injector = inject(Injector);

  public ES_IS_AVAILABLE: boolean;

  handleError(error) {
    // const loggingService = this.injector.get(EsService);
    const location = this.injector.get<LocationStrategy>(LocationStrategy as any);
    location instanceof PathLocationStrategy ? location.path() : "";

    if (this.ES_IS_AVAILABLE) {
      StackTrace.fromError(error).catch(() => undefined);
    }

    /* hide error from console (when commented) */
    throw error;
  }
}
